import { type I18n, i18nFormat } from "@common/lib/i18n";
import Network from "@common/modules/network/types";

export const formatRewardTitle = (i18n: I18n, reward: Network.Incentives.Reward, index: number) =>
  i18nFormat(
    i18n.affiliateCompetitionPrizeDescriptionInfo,
    ["NUMBER", index + 1],
    ["PERCENT", reward.budgetPercentage * 100]
  );
